import { TPO_ACCOUNTS_API_BASE_URL, TPO_SIGNING_API_BASE_URL } from 'constants/api';

/**
 * The embedded `@lender/signing-custom-service` resolves its signing/accounts API base
 * URLs from `window.signingApiBaseUrl` / `window.accountsApiBaseUrl`, falling back to
 * `process.env.{SIGNING,ACCOUNTS}_API_BASE_URL`. The TPO build only injects `TPO_`-prefixed
 * env, so neither the window globals nor those process vars are ever set — leaving the
 * signing embed's axios `baseURL` undefined. It then fetches the SigningRequest and PDF
 * from the page origin (the SPA), which returns HTML, and the surface fails with
 * "Could not get PDF" so the signer can never sign.
 *
 * The component builds its axios instances at module-evaluation time, so the globals must
 * exist before that module is imported. This module is imported first in `index.tsx`,
 * before the app (and thus before the signing component) is evaluated.
 */
declare global {
  interface Window {
    signingApiBaseUrl?: string;
    accountsApiBaseUrl?: string;
  }
}

window.signingApiBaseUrl = TPO_SIGNING_API_BASE_URL;
window.accountsApiBaseUrl = TPO_ACCOUNTS_API_BASE_URL;

export {};
